import { useRef } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { SwipeCard } from "@/components/SwipeCard";
import { SwipeActions } from "@/components/SwipeActions";
import { STATUS_INFO } from "@/components/SearchResultRow";

const ALL_DIRS = ["left", "down", "up", "right"];
const DIR_FOR_STATUS = { passed: "left", disliked: "down", liked: "up", watchlist: "right" };

export function SearchRateDialog({ movie, onClose, onDone, onDetails }) {
  const cardRef = useRef(null);
  const dirs = ALL_DIRS.filter((d) => d !== DIR_FOR_STATUS[movie?.status]);
  const current = STATUS_INFO[movie?.status];
  return (
    <Dialog open={!!movie} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm bg-transparent border-0 shadow-none p-0" data-testid="search-rate-dialog">
        <DialogTitle className="sr-only">{movie?.title}</DialogTitle>
        <DialogDescription className="sr-only">Swipe or tap a button to record your opinion.</DialogDescription>
        {movie && (
          <div className="flex flex-col gap-4">
            <p className="text-center text-sm text-white/80" data-testid="search-rate-current">
              {current ? <>Currently in <span className="font-semibold">{current.label}</span> · pick a new spot</> : "Swipe or tap to record it"}
            </p>
            <div className="relative w-full h-[460px] max-h-[58vh]">
              <SwipeCard key={movie.movie_id} ref={cardRef} movie={movie} allowed={dirs} onSwipe={(d) => onDone(movie, d)} onDetails={onDetails} />
            </div>
            <SwipeActions order={dirs} onAction={(d) => cardRef.current?.fly(d)} />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
